import { render, staticRenderFns } from "./viewDataAuthority.vue?vue&type=template&id=50922eb5&"
import script from "./viewDataAuthority.vue?vue&type=script&lang=js&"
export * from "./viewDataAuthority.vue?vue&type=script&lang=js&"
import style0 from "./viewDataAuthority.vue?vue&type=style&index=0&id=50922eb5&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports